
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SlotActionsProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a slot action provider for the purpose of contributing a slot action
 */
define([], () => {
	class SlotActionsProviderAPI {

		/**
		 * @function SlotActionsProviderAPI#getSlotActionList
		 * @description Returns a list of slotActions available for a specific item given a data slot and an item index.
		 * @param {dataSlotId} id of the dataSlot
		 * @param {itemIndex} index of the dataItem
		 * @param {options} {actionOptions: {}, actionsToKeep: {}}
		 * @return {array} array containing all available actions
		 */
		getSlotActionList(/* dataSlotId, itemIndex, options */) {}

	}

	return SlotActionsProviderAPI;
});